module.exports = __webpack_public_path__ + "img/29_61.c3ead8e5.png";